import {
  LevelDiscount,
  type LevelType,
} from "@/screens/rewards/components/LevelDiscount"
import { type ReactNode } from "react"
import { Body, H3 } from "@/components/standard/BFText"
import { Center } from "@/components/standard/BFLayout"
import { useCurrentTier } from "@/screens/rewards/utils"

export const AvailableRewards = ({ children }: { children?: ReactNode }) => {
  const { currentTier } = useCurrentTier()

  if (!currentTier) {
    return (
      <Center className={"px-10 flex-col"}>
        <H3 className={"text-midnight-blue mb-1"}>Earn as You Grow</H3>
        <Body className={"text-midnight-blue"}>
          Close your first deal with Backflip to start earning discounts on
          future closes.
        </Body>
      </Center>
    )
  }

  return (
    <>
      {children}
      {currentTier && <LevelDiscount level={currentTier.name as LevelType} />}
    </>
  )
}
